$(function(){

  $("header").addClass("positive");
  
  setTimeout(function(){
    $("#colabLogo").addClass("active");
    setTimeout(function(){
      $("header").addClass("active");
      $("#mainVisual").addClass("active");
     // $(mainSlider).slick('slickPlay');
    }, 1000);
  }, 1600);

  
  
  //mainvisual slider
  var swiper = new Swiper('.swiper-container', {
      autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },

    loop: true,
    effect: 'fade',
    slidesPerView: 'auto',

    keyboard: {
      enabled: true,
      onlyInViewport: false,
    },

    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });
  
  var swiper2 = new Swiper('.swiper-container2', {
    loop: true,
    effect: 'fade',
    slidesPerView: 'auto',

    keyboard: {
      enabled: true,
      onlyInViewport: false,
    },

    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });

  //list ID
  
  $('#articleLink li').each(function(i){
    $(this).attr('id','articleLink' + (i+1));
  });
  
  $('#articleLinkJp li').each(function(i){
    $(this).attr('id','articleLinkJp' + (i+1));
  });
  
  $('#articleInnerList li').each(function(i){
    $(this).attr('id','articleInnerList' + (i+1));
  });
  
  $(window).bind("load resize", init);
    function init(){
      var _width = $(window).width();
      if(_width <= 768){
        //for SP
        
        //smooth scroll
        
        var h = $(window).height();
        $("#mainVisual, .mainVisualSlider li").not(".slick-dots li").css("height", h + "px");
        
        $('#articleInnerList ul li').unbind( "click" );
        $('#articleInnerList ul li').click(function(){

          var speed = 800; 
          var href= $(this).attr("href");
          var self = $(this);
          var target = $(href == "#" || href == "" ? 'html' : href);

          $(this).children('.articleInnerTxt').slideToggle(600);
          $('.articleInnerTxt').not($(this).children('.articleInnerTxt')).slideUp(0);

          $('html, body').animate({ scrollTop: self.offset().top-48 }, {
            queue : false
          });

          $(this).toggleClass("open");
          $('#articleInnerList li').not(self).removeClass("open");
          
        });

		}else{
      //for PC
      
      $("#articleInnerList").hide();
      $(".articleInnerTxt").show();
      
      $("#articleInnerList1 h3").appendTo("#articleLink1 a");
      $("#articleInnerList2 h3").appendTo("#articleLink2 a");
      $("#articleInnerList3 h3").appendTo("#articleLink3 a");
      $("#articleInnerList4 h3").appendTo("#articleLink4 a");
      $("#articleInnerList5 h3").appendTo("#articleLink5 a");
      $("#articleInnerList6 h3").appendTo("#articleLink6 a");
      $("#articleInnerList7 h3").appendTo("#articleLink7 a");
      $("#articleInnerList8 h3").appendTo("#articleLink8 a");
      $("#articleInnerList9 h3").appendTo("#articleLink9 a");
      $("#articleInnerList10 h3").appendTo("#articleLink10 a");
      $("#articleInnerList11 h3").appendTo("#articleLink11 a");
      $("#articleInnerList12 h3").appendTo("#articleLink12 a");
      $("#articleInnerList13 h3").appendTo("#articleLink13 a");
      $("#articleInnerList14 h3").appendTo("#articleLink14 a");

      $("#articleInnerList1 h4").appendTo("#articleLinkJp1 a");
      $("#articleInnerList2 h4").appendTo("#articleLinkJp2 a");
      $("#articleInnerList3 h4").appendTo("#articleLinkJp3 a");
      $("#articleInnerList4 h4").appendTo("#articleLinkJp4 a");
      $("#articleInnerList5 h4").appendTo("#articleLinkJp5 a");
      $("#articleInnerList6 h4").appendTo("#articleLinkJp6 a");
      $("#articleInnerList7 h4").appendTo("#articleLinkJp7 a");
      $("#articleInnerList8 h4").appendTo("#articleLinkJp8 a");
      $("#articleInnerList9 h4").appendTo("#articleLinkJp9 a");
      $("#articleInnerList10 h4").appendTo("#articleLinkJp10 a");
      $("#articleInnerList11 h4").appendTo("#articleLinkJp11 a");
      $("#articleInnerList12 h4").appendTo("#articleLinkJp12 a");
      $("#articleInnerList13 h4").appendTo("#articleLinkJp13 a");
      $("#articleInnerList14 h4").appendTo("#articleLinkJp14 a");
      
      $("#articleInnerList1 .articleInnerTxt").appendTo("#atrticleTokyo .articleTxtInner");
      $("#articleInnerList2 .articleInnerTxt").appendTo("#atrticleHokkaido .articleTxtInner");
      $("#articleInnerList3 .articleInnerTxt").appendTo("#atrticleTohoku .articleTxtInner");
      $("#articleInnerList4 .articleInnerTxt").appendTo("#atrticleKanto .articleTxtInner");
      $("#articleInnerList5 .articleInnerTxt").appendTo("#atrticleChubu .articleTxtInner");
      $("#articleInnerList6 .articleInnerTxt").appendTo("#atrticleKinki .articleTxtInner");
      $("#articleInnerList7 .articleInnerTxt").appendTo("#atrticleChugoku .articleTxtInner");
      $("#articleInnerList8 .articleInnerTxt").appendTo("#atrticleShikoku .articleTxtInner");
      $("#articleInnerList9 .articleInnerTxt").appendTo("#atrticleKyushu .articleTxtInner");
      $("#articleInnerList10 .articleInnerTxt").appendTo("#atrticleRussia .articleTxtInner");
      $("#articleInnerList11 .articleInnerTxt").appendTo("#atrticleChina .articleTxtInner");
      $("#articleInnerList12 .articleInnerTxt").appendTo("#atrticleHongkong .articleTxtInner");
      $("#articleInnerList13 .articleInnerTxt").appendTo("#atrticleTaiwan .articleTxtInner");
      $("#articleInnerList14 .articleInnerTxt").appendTo("#atrticleKorea .articleTxtInner");

		}
	}

  if($(window).width() < 769){
    //for SP
    var h = $(window).height();
    $("#mainVisual, #mainVisual a, #mainVisual li img").css("height", h + "px");

  } else {
    //for PC
    
  }
  
  var target = $('#mainVisual');
  var targetHeight = target.outerHeight();

  $(document).scroll(function(e){
    var scrollPercent = (targetHeight - window.scrollY) / targetHeight;
    if(scrollPercent >= 0){
      target.css('opacity', scrollPercent);
    }
  });
  

  //$("header").addClass("positive");
  
  
  $("#mainVisual").waypoint(function(direction){
    if(direction == 'down'){
      $("header").removeClass("bg").addClass("positive");
      
      //btnMenu
      $('#btnMenu').click(function(){
        if($("#closeOverlay").hasClass('active')){
          $("header").addClass("positive");
        } else {
          $("header").removeClass("positive");
        }
      });
      
      } else {
        $("header").addClass("bg").removeClass("positive");
    }
  });
  
  $("#mainContents").waypoint(function(direction){
    if(direction == 'down'){
      $("header").removeClass("positive").addClass("bg");
      
      //btnMenu
      $('#btnMenu').click(function(){
        if($("#closeOverlay").hasClass('active')){
          
        } else {
          $("header").removeClass("positive");
        }
      });
      
    } else {
    }
  });
  
  $("#mainContents").waypoint(function(direction){
    if(direction == 'up'){
      $("header").addClass("positive").removeClass("bg");
      
      //btnMenu
      $('#btnMenu').click(function(){
        if($("#closeOverlay").hasClass('active')){
          
        } else {
          $("header").addClass("positive");
        }
      });
      
    } else {
    }
  });
  
//  if($(window).width() < 769){
//    //for SP
//
//  } else {
//    //for PC
//    
//    var lookHeight = $("#look").height();
//    var waypoint = new Waypoint({
//      element: document.getElementById('look'),
//      handler: function(direction){
//        if (direction === 'down') {
//          $("#look").addClass("fixed");
//          $("#lookDummy").css("height",lookHeight+160);
//          $("#brandConceopt").addClass("active");
//        }
//        else {
//          $("#look").removeClass("fixed");
//          $("#lookDummy").css("height","auto");
//          $("#brandConceopt").removeClass("active");
//        }
//
//      },
//      offset: 'bottom-in-view'
//    });
//    
//  }

  if ($(window).width() < 769) {
		sa = 80;
	} else {
		sa = 320;
	}
  
});


$(window).load(function(){

  

  var lookHeight = $("#look").height();
  var waypoint = new Waypoint({
    element: document.getElementById('look'),
    handler: function(direction){
      if (direction == 'down') {
        $("#look").addClass("fixed");
        $("#lookDummy").css("height",lookHeight+sa);
        $("#brandConceopt").addClass("active");
      }
      else {
        $("#look").removeClass("fixed");
        $("#lookDummy").css("height","0");
        $("#brandConceopt").removeClass("active");
      }

    },
    offset: 'bottom-in-view'
  });
  
  $("#look").waypoint(function(direction){
    if(direction == 'down'){
      $("#movie").css("opacity","0");
    } else {
      $("#movie").css("opacity","1");
    }
  });


});